import { cva } from "class-variance-authority";

export const inputVariants = cva(
  "flex w-full rounded-lg border bg-white px-3 py-2 text-sm transition-colors placeholder:text-gray-400 outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50",
  {
    variants: {
      variant: {
        default: "border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500",
        error: "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-500",
      },
      inputSize: {
        default: "h-12",
        sm: "h-10 px-2 text-xs",
        lg: "h-14 px-4 text-base",
      },
    },
    defaultVariants: {
      variant: "default",
      inputSize: "default",
    },
  }
);
